export type HelpTicketCategory =
  | 'commercial_not_loading'
  | 'inventory_not_available'
  | 'technical_issue'
  | 'other';

export const HELP_TICKET_CATEGORIES: { value: HelpTicketCategory; label: string }[] = [
  { value: 'commercial_not_loading', label: 'Commercial not loading' },
  { value: 'inventory_not_available', label: 'Inventory not available' },
  { value: 'technical_issue', label: 'Technical issue' },
  { value: 'other', label: 'Other' },
];

export function categoryLabel(value: string): string {
  return HELP_TICKET_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}
